<template>
    <el-dialog
        title="提示"
        :visible.sync="dialogVisible"
        :before-close="handleClose">
        <div class="form f-b">
            <div>
                <el-select v-model="searchParams.searchType" placeholder="请选择" style="width: 120px" class="selectGroup" @change="resetPage">
                    <el-option label="商品名称" :value="2"></el-option>
                    <el-option label="Item Id" :value="1"></el-option>
                </el-select>
                <el-popover
                    placement="bottom"
                    width="400"
                    trigger="click">
                    <el-input type="textarea" v-model="searchParams.searchName" placeholder="根据换行分隔" :rows="5" @change="resetPage"></el-input>
                    <el-input placeholder="请输入内容" v-model="searchParams.searchName" class="inputGroup" style="width: 340px;" clearable slot="reference" @change="resetPage"></el-input>
                </el-popover>
                <el-checkbox v-model="discountIdFlag" style="margin: 0 10px" @change="resetPage">只看未参加活动</el-checkbox>
            </div>
            <!-- <div>
                <el-button type="primary" @click="resetPage">搜索</el-button>
                <el-button @click="resetForm">重置</el-button>
            </div> -->
        </div>
        <section class="common-section">
            <el-table
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                row-key="kkProductId"
                v-loading="loading">
                <el-table-column
                    type="selection"
                    :reserve-selection="true"
                    :selectable="selectable"
                    width="55">
                </el-table-column>
                <el-table-column label="图片" width="100">
                    <template slot-scope="{row}">
                        <el-popover placement="right" width="280" trigger="hover">
                            <el-image :src="row.images" fit="cover" />
                            <el-image slot="reference" :src="row.images" fit="cover" class="stock-img" />
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="name"
                    label="产品信息">
                    <template slot-scope="scope">
                        <div>{{ scope.row.productName }}</div>
                        <div style="color: lightBlue">Item No: {{ scope.row.spuCode }}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="virtualStockTotal"
                    label="库存"
                    width="100"
                    align="center">
                </el-table-column>
                <el-table-column
                    prop="salesVolume"
                    label="是否正在参加活动"
                    width="140"
                    align="center">
                    <template slot-scope="scope">
                        {{ !!scope.row.discountId ? '是': '否' }}
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="parameter.pageNumber"
                :page-sizes="[50, 100, 200, 500]"
                :page-size="parameter.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </section>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="selectSelection">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import API from '@/api'
export default {
    data() {
        return {
            dialogVisible: false,
            categoryOptions: [], // 筛选 - 商品品类级联选择器数据源
            parameter: {
                status: 1,
                pageNumber: 1,
                pageSize: 50
            },
            searchParams: {
                searchName: undefined,
                searchType: 1
            },
            searchName: undefined,
            selectValue: 1,
            selectV: undefined,
            total: 23333333333,
            tableData: [],
            selectionAll: [],
            categoryValue: [],
            discountIdFlag: true,
            loading: false
        }
    },
    created() {
        // this.getCategoryList()
    },
    methods: {
        handleClose() {
            this.$refs.multipleTable.clearSelection()
            this.selectionAll = []
            this.dialogVisible = false
        },
        // 获取品类列表
        async getCategoryList() {
            let { data } = await API.getCategoryList({ pageNumber: 1, pageSize: 1000 })
            if (data && data.list.length) {
                this.deletechildList(data.list)
                this.categoryOptions = data.list
            }
        },
        deletechildList(arr) { // 删除最后一级为空的childList字段
            arr.forEach((item) => {
                if (!item.childList.length) {
                    delete item.childList
                } else {
                    this.deletechildList(item.childList)
                }
            })
        },
        getParams() {
            const params = Object.assign({}, this.parameter, this.searchParams)
            if(this.discountIdFlag) params.discountIdFlag = 1
            if(params.searchName) {
                let searchNameArrays = params.searchName.split('\n').filter(e=>e)
                searchNameArrays.length ? params.searchNameArrays = searchNameArrays : params.searchNameArrays = undefined
            }
            params.searchName = undefined
            if(this.categoryValue.length) params.categoryIds = this.categoryValue
            return params
        },
        async getList() {
            try {
                this.loading = true
                const params = this.getParams()
                const res = await API.promotionGetProductList(params)
                this.loading = false
                if(res.code !== 10000) {
                    this.$message.error(res.data || '获取商品失败')
                    return
                }
                this.total = res.data.total
                this.tableData = res.data.list
            } catch (error) {
                this.loading = false
                this.$message.error(error)
            }
        },
        show() {
            this.getList()
            this.dialogVisible = true
        },
        selectSelection() {
            this.$emit('selectSelection', this.$refs.multipleTable.selection)
            this.dialogVisible = false
        },
        handleCurrentChange(page) {
            this.parameter.pageNumber = page
            this.getList()
        },
        handleSizeChange(size) {
            this.parameter.pageSize = size
            this.getList()
        },
        resetPage() {
            this.parameter.pageNumber = 1
            this.getList()
        },
        resetForm() {
            this.categoryValue = []
            this.selectValue = 'productName'
            this.searchName = undefined
            this.parameter.status = undefined
            this.discountIdFlag= false
            this.getList()
        },
        selectable(row) {
            return !row.discountId
        }
    },
}
</script>

<style lang="scss" scoped>
.el-select .el-input {
    width: 130px;
}
.input-with-select {
    /deep/.el-input-group__prepend {
        width: 120px;
        background-color: #fff;
    }
}
.el-cascader {
    /deep/.el-input__inner {
        height: 40px !important;
    }
}
.statusSelect {
    /deep/.el-input__inner {
        height: 40px !important;
    }
}
.common-section {
    // height: calc(100vh - 194px);
    margin: 12px 0;
    .stock-img {
      width: 60px;
      height: 60px;
      border-radius: 4px;
      overflow: hidden;
      border: 1px solid #f5f7fa;
      user-select: none;
      cursor: pointer;
    }
  }
/deep/.el-dialog {
    min-width: 1300px;
}
/deep/.el-cascader {
    width: 300px;
}
.inputGroup {
    /deep/.el-input__inner {
        border-top-left-radius: 0px;
        border-bottom-left-radius: 0px;
    }
}
.selectGroup {
    /deep/.el-input__inner {
        border-top-right-radius: 0px;
        border-bottom-right-radius: 0px;
    }
}
</style>
